import { useState, useEffect, useRef } from "react";

export default function BottomSheet({open,onClose,children,locked=false}) {
  const [visible,setVisible]=useState(false);
  const [animIn,setAnimIn]=useState(false);
  const dragY=useRef(null);
  useEffect(()=>{
    if(open){setVisible(true);requestAnimationFrame(()=>requestAnimationFrame(()=>setAnimIn(true)));}
    else{setAnimIn(false);const t=setTimeout(()=>setVisible(false),400);return()=>clearTimeout(t);}
  },[open]);
  if(!visible) return null;
  return (
    <div style={{position:"fixed",inset:0,zIndex:200,display:"flex",flexDirection:"column",justifyContent:"flex-end"}}>
      <div onClick={locked ? undefined : onClose} style={{position:"absolute",inset:0,background:"#000",opacity:animIn?.55:0,transition:"opacity .38s ease",backdropFilter:animIn?"blur(4px)":"none"}}/>
      <div
        onTouchStart={e=>{
          // Only track single finger drag — ignore pinch (2+ fingers)
          if(e.touches.length===1) dragY.current=e.touches[0].clientY;
          else dragY.current=null;
        }}
        onTouchEnd={e=>{
          // Only close on single finger downward swipe — never on pinch
          if(dragY.current!==null&&e.changedTouches.length===1&&e.changedTouches[0].clientY-dragY.current>60&&!locked) onClose();
          dragY.current=null;
        }}
        onTouchMove={e=>{
          // If second finger added mid-gesture, cancel drag tracking
          if(e.touches.length>1) dragY.current=null;
        }}
        style={{position:"relative",zIndex:1,background:"#08111f",borderRadius:"22px 22px 0 0",maxHeight:"92vh",minHeight:"80vh",overflowY:"auto",border:"1px solid #1e293b",borderBottom:"none",transform:animIn?"translateY(0)":"translateY(105%)",transition:"transform .42s cubic-bezier(.32,0,.67,0)",boxShadow:"0 -20px 60px rgba(0,0,0,.7)",touchAction:"pan-y"}}>
        <div style={{display:"flex",justifyContent:"center",padding:"12px 0 4px"}}>
          <div style={{width:36,height:4,borderRadius:2,background:"#1e293b"}}/>
        </div>
        {children}
      </div>
    </div>
  );
}
